import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Layout } from "src/base/store/layoutSlice";
import { ReduxDataKey } from "src/base/store/store";

const MiddlewareVersionRoute = () => {
  const location = useLocation();
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);

  console.log("ebsssLayout?.commonAppSettings?.crm_v2_default_homepage: ", ebsssLayout?.commonAppSettings?.crm_v2_default_homepage);

  if (
    (window.location.pathname === "/" || window.location.pathname === "" || window.location.pathname === "/v2") &&
    ebsssLayout?.commonAppSettings?.crm_v2_default_homepage
  ) {
    return <Navigate to={`${process.env.PUBLIC_URL}`} />;
  }

  if (location.pathname === "/" || location.pathname === process.env.PUBLIC_URL || location.pathname === process.env.PUBLIC_URL + "/") {
    let hasDefinedInitialPage = ebsssLayout?.template?.pages?.find((lg: { type: string }) => lg.type === "ini_page");
    let hasQueryParams = location.search;
    return (
      <Navigate
        to={process.env.PUBLIC_URL + "/" + (hasDefinedInitialPage && hasDefinedInitialPage.slug !== "/" ? hasDefinedInitialPage?.slug : "") + hasQueryParams}
      />
    );
  }

  return location.pathname.startsWith(process.env.PUBLIC_URL) ? (
    <Outlet />
  ) : (
    <Navigate to={`${process.env.PUBLIC_URL}${location.pathname}${location.search}`} />
  );
};
export default MiddlewareVersionRoute;
